import yaml from 'js-yaml'
import { toRaw } from 'vue'
import { defineStore } from 'pinia'

export const yamlToObject = (string) => {
  try { return yaml.load(string) }
  catch { return null }
}

export const yamlToArray = (string) => {
  try {
    const parsed = yaml.load(string)
    return Array.isArray(parsed) ? parsed : parsed ? [parsed] : []
  } catch { return [] }
}

export const cleanUpJSON = (input) => JSON.parse(JSON.stringify(input))

export const pathName = (input) => {
  try { return input ? new URL(input).pathname : '#' }
  catch { return input || '#' }
}

export const crossOriginSRCSET = (srcset) => {
  if (!srcset) return ''
  return srcset.split(', ').map(part => {
    const [url, descriptor] = part.split(' ')
    try { return `${new URL(url).pathname} ${descriptor}` }
    catch { return part }
  }).join(', ')
}

export const crossOriginSrc = (src) => {
  try { return new URL(src).pathname }
  catch { return src }
}

export const pageFromPath = (path, pages) => {
  if (!path || !pages) return null
  const slugs = path.trim().replace(/^\//, '').split('/').filter(Boolean)
  let children = pages
  let page = null
  for (const slug of slugs) {
    page = children?.find?.(p => p.uid === slug) ?? null
    if (!page) return null
    children = page.children ?? []
  }
  return page
}

export const alternativeLanguage = () => {
  const el = document.head.querySelector('link[rel=alternate]')
  return el?.attributes?.hreflang?.value ?? false
}

export const routeStore = defineStore('routes', () => {
  const route = useRoute()
  const visitedURLs = ref([])
  watch(route, (r) => visitedURLs.value.unshift(r.path))
  return { route, visitedURLs }
})
